<template>
  <b-card title="ผลการค้นหา">
    <slot></slot>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      @on-row-click="onRowClick"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <span v-if="props.column.field === 'clueCode'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.clueCode }}</span>
        </span>

        <span v-if="props.column.field === 'clueDetail'" class="text-nowrap">
          <span
            v-if="props.row.companyName != null && props.row.companyName != ''"
          >
            <span
              class="text-nowrap"
              v-b-tooltip.hover
              :title="props.row.companyName"
            >
              <feather-icon icon="BriefcaseIcon" class="mr-50" />
              {{ props.row.companyName.substring(0, 50)
              }}{{ props.row.companyName.length >= 50 ? "..." : "" }}
            </span>
          </span>
          <span v-else>ไม่ระบุ</span>
          <br />
          <span class="text-nowrap">
            {{ props.row.name }} {{ props.row.lastname }}</span
          >
        </span>

        <span v-if="props.column.field === 'clueStatus'" class="text-nowrap">
          <span class="text-nowrap"
            >{{ props.row.clueDateStr }} / {{ props.row.channelName }}</span
          >
          <!-- <br />
          <span class="text-nowarp">
            {{ props.row.leveldescription }}-{{ props.row.statusdescription }}
          </span> -->
          <!-- <br />
          <span class="text-nowarp">
            {{ props.row.channelName }}
          </span> -->
        </span>

        <span v-if="props.column.field === 'clueAgency'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.deptname }}</span>
        </span>

        <!-- Column: Action -->

        <!-- <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>

              <b-dropdown-item @click="onManageBtnClicked(props.row.clueId)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span v-if="clueAction==='Search'">ดูรายละเอียด</span>
                <span v-else-if="clueAction==='Check'">ตรวจสอบ</span>
                <span v-else>ดำเนินการ</span>
              </b-dropdown-item>

            </b-dropdown>
          </span>
        </span> -->

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./commonTableHeader.js";
import * as clueStore from "@/store/api/clue/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import appsettings from "@/store/app-settings";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
    VBTooltip,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
    clueAction: {
      type: String,
      required: true,
      default: "Action",
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns:
        this.mode == "List" || this.mode == "Group"
          ? TableHeaders
          : TableHeadersGroupProcess,
      rows: [],
      searchTerm: "",
      params: {},
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    // this.onSearchSubmit({});
  },
  methods: {
    onSearchSubmit(params, page = { currentPage: 1 }) {
      console.log("ทดสอบ", params, this.clueAction, userData.departmentId());

      this.params = params;

      params.page = page.currentPage;
      params.perPage = this.pageLength;

      params.departmentId = null;
      if (this.clueAction !== "Search") {
        // ถ้าไม่ใช่คัดกรองจะแสดงเฉพาะกองนั้น ๆ
        // *** แจ้งเบาะแสหน้าค้นหากับหน้าดำเนินการแสดงข้อมูลแบบเดียวกันคือ เห็นเหมือนกันทั้งหมด
        // *** โดยหน้าค้นหาจะแสดงข้อมูลก็ต่อเมื่อกดค้นหา ส่วนดำเนินการจะแสดงข้อมูลทันที
        if (
          userData.departmentId().toLowerCase() !==
          appsettings.clueDepartmentID.screening.toLowerCase()
          || userData.departmentId().toLowerCase() !==
          appsettings.clueDepartmentID.screeningOld.toLowerCase()
        ) {
          params.departmentId = userData.departmentId();
        }
      }

      // params.userActive = userData.userId();
      // params.provinceCode = userData.province()
      this.$emit("handleOverlay", true);
      var _this = this;
      clueStore
        .getForSearch(params)
        .then(function(response) {
          // handle success
          console.log("getForSearch", response);
          _this.rows = response.data.data;
          console.log("result", _this.rows);
          try {
            _this.totalRecords = response.data.data[0].totalCount;
          } catch (ex) {
            console.log("get total records error", ex);
            _this.totalRecords = 0;
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
          _this.totalRecords = 0;
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    onManageBtnClicked(id) {
      // รับมาเป็น clueId
      this.$emit("handleManage", id);
    },
    onRowClick(params) {
      console.log("clueAction", this.clueAction);

      if (this.clueAction === "Search") {
        this.$emit("handleManage", params.row.clueId);
      } else {
        // *** ด้วยความที่เมนูดำเนินการของคัดกรองจะมองเห็นทุกเรื่อง
        // *** ในกรณีที่อยู่คัดกรองแต่เลือกเรื่องที่ไม่ได้อยู่คัดกรอง พอกดเข้าไปแล้วจะแสดงแค่ประวัติเท่านั้น
        if (userData.departmentId().toLowerCase() === params.row.departmentID) {
          this.$emit("handleManage", params.row.clueId);
        } else {
          this.$emit("handleManageSearch", params.row.clueId);
        }
      }
    },
    onDeleteBtnClicked(id) {
      const _this = this;

      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          roleStore
            .deleteItem(id)
            .then((response) => {
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                this.onSearchSubmit({});
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onComplainSend(id) {
      this.$emit("handleSend", id);
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
